var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 105,
    viewBox: "0 0 106 105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9156",
    "data-name": "Group 9156",
    transform: "translate(0 -0.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9135",
    "data-name": "Group 9135",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1647",
    "data-name": "Ellipse 1647",
    cx: 53,
    cy: 52.5,
    rx: 53,
    ry: 52.5,
    transform: "translate(0 0.499)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9157",
    "data-name": "Group 9157",
    transform: "translate(24.162 26.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_23-certificate",
    "data-name": " 23-certificate",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "filled",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19690",
    "data-name": "Path 19690",
    d: "M60.35,36H20.587c-.038,0-.075,0-.113,0a6.777,6.777,0,0,0-6.567,6.773V81.185H6.226A1.356,1.356,0,0,0,4.87,82.541a6.785,6.785,0,0,0,6.778,6.778H49.505a6.785,6.785,0,0,0,6.778-6.778V42.778a4.071,4.071,0,0,1,4.067-4.067,1.356,1.356,0,1,0,0-2.711Zm-48.7,50.608A4.074,4.074,0,0,1,7.813,83.9h35.05a6.754,6.754,0,0,0,1.223,2.711Zm41.924-43.83V82.541a4.067,4.067,0,0,1-8.133,0h0a1.356,1.356,0,0,0-1.356-1.356H16.618V42.778a4.086,4.086,0,0,1,3.993-4.065l.054,0H54.931A6.744,6.744,0,0,0,53.572,42.778Z",
    transform: "translate(-4.87 -36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19691",
    "data-name": "Path 19691",
    d: "M149.235,107.8l3.349.309,1.762,2.866a1.355,1.355,0,0,0,1.152.646h0a1.356,1.356,0,0,0,1.151-.64l5.21-8.386a1.279,1.279,0,0,0,.3,0l5.21,8.386a1.355,1.355,0,0,0,1.152.64h0a1.355,1.355,0,0,0,1.152-.646l1.762-2.866,3.349-.309a1.356,1.356,0,0,0,1.027-2.065l-5.445-8.763a7.334,7.334,0,0,0,2.033-4.761c0-3.379-1.444-6.251-3.768-7.495-1.146-.613-3.467-1.308-6.625.481-3.158-1.789-5.479-1.094-6.625-.481-2.324,1.244-3.768,4.116-3.768,7.495a7.332,7.332,0,0,0,2.033,4.761l-5.443,8.763a1.356,1.356,0,0,0,1.027,2.065Zm21.28-2.328a1.356,1.356,0,0,0-1.03.64l-.968,1.575-3.892-6.264a29.059,29.059,0,0,0,2.7-1.724q.555-.4,1.048-.806l3.981,6.41ZM156.665,87.1a2.966,2.966,0,0,1,1.421-.347,6.055,6.055,0,0,1,3.173,1.157,1.355,1.355,0,0,0,1.5,0c1.241-.827,3.045-1.639,4.594-.81,1.419.76,2.336,2.763,2.336,5.1,0,3.03-5,6.179-7.529,7.461a1.275,1.275,0,0,0-.115.058l-.037.019-.037-.018c-.038-.021-.077-.041-.116-.058-2.533-1.282-7.529-4.431-7.529-7.46,0-2.342.917-4.345,2.336-5.1ZM155.65,98.889q.495.4,1.048.806a29.066,29.066,0,0,0,2.7,1.724l-3.892,6.264-.968-1.575a1.356,1.356,0,0,0-1.03-.64l-1.84-.169Z",
    transform: "translate(-131.835 -78.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19692",
    "data-name": "Path 19692",
    d: "M144.2,340H133.356a1.356,1.356,0,0,0,0,2.711H144.2a1.356,1.356,0,1,0,0-2.711Z",
    transform: "translate(-117.639 -305.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19693",
    "data-name": "Path 19693",
    d: "M292,341.356a1.356,1.356,0,0,0,1.355,1.356H304.2a1.356,1.356,0,0,0,0-2.711H293.356A1.356,1.356,0,0,0,292,341.356Z",
    transform: "translate(-259.565 -305.659)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19694",
    "data-name": "Path 19694",
    d: "M158.393,388h-9.037a1.356,1.356,0,1,0,0,2.711h9.037a1.356,1.356,0,0,0,0-2.711Z",
    transform: "translate(-131.832 -348.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19695",
    "data-name": "Path 19695",
    d: "M302.393,388h-9.037a1.356,1.356,0,0,0,0,2.711h9.037a1.356,1.356,0,0,0,0-2.711Z",
    transform: "translate(-259.565 -348.237)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/Certificate.0b607903e1397270f8f6d32a0a5b1b51.svg";
export { ForwardRef as ReactComponent };